/* Bloomistry theme — core interactions (vanilla, progressive enhancement).
   Cart reads and predictive search go through window.BLM.routes (layout/theme.liquid). Everything here
   ENHANCES; the theme must remain usable with this file absent (forms post to
   /cart/add and /search; links navigate). Target ≤16KB (see docs perf budget). */
(function(){
  'use strict';
  /* Marks the page as scripted, so controls that only exist for a no-JS visitor can take
     themselves off the page instead of sitting there doing nothing. */
  document.documentElement.classList.add('js');
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  window.BLM=window.BLM||{};

  /* This block lives INSIDE the IIFE because it uses $$ — it was stranded above it once, and
     the whole file died on line 8 with "ReferenceError: $$ is not defined", taking every
     site-wide behaviour with it. Nothing may be added above the IIFE opener. */
  /* ---------- header category jump ----------
     Navigates only when the search box is empty — with a query typed the customer clearly wants to
     search, so the form is submitted instead of their words being discarded.

     And never on a bare `change`: arrowing through a closed <select> fires `change` per option in
     Firefox and on Windows, so a keyboard user was navigated away before reaching the third
     category. Keyboard interaction waits for Enter or for focus to leave. */
  $$('[data-search-cat]').forEach(function(sel){
    var viaKeyboard=false, pending=false;
    function go(){
      if(!sel.value) return;
      var form=sel.closest('form');
      var q=form&&form.querySelector('input[name="q"]');
      if(q&&q.value.trim()){ form.submit(); return; }
      window.location=sel.value;
    }
    sel.addEventListener('keydown',function(e){
      viaKeyboard=true;
      if(e.key==='Enter'){ e.preventDefault(); pending=false; go(); }
    });
    sel.addEventListener('mousedown',function(){ viaKeyboard=false; });
    sel.addEventListener('change',function(){ if(viaKeyboard){ pending=true; return; } go(); });
    sel.addEventListener('blur',function(){ if(pending){ pending=false; go(); } });
  });
  /* Shopify.formatMoney lives in shopify_common.js, which this theme does not load — the old
     ternary silently fell through to a bare "245.00" with no currency. This formats from the
     shop's own money_format instead, so it follows whatever the merchant has configured. */
  function money(cents){
    var n=(Number(cents)||0)/100;
    var fmt=(window.BLM&&BLM.moneyFormat)||'{{amount}}';
    var lang=(document.documentElement.getAttribute('lang')||'en').toLowerCase();
    var loc=lang.indexOf('ar')===0?'ar-AE-u-nu-latn':'en-AE';
    function num(dec){
      try{ return n.toLocaleString(loc,{minimumFractionDigits:dec,maximumFractionDigits:dec}); }
      catch(e){ return n.toFixed(dec); }
    }
    return String(fmt)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,num(0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,num(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,num(0))
      .replace(/\{\{\s*amount\s*\}\}/g,num(2))
      .replace(/<[^>]*>/g,'')
      .trim();
  }
  BLM.money=money;
  /* Text -> HTML-safe text. Every string that reaches innerHTML goes through this; product
     titles legitimately contain & and <. */
  function esc(t){
    var d=document.createElement('div');
    d.textContent=t==null?'':String(t);
    /* textContent escapes & < > but NOT quotes, so the result is unsafe inside an attribute.
       Escaping both makes one helper correct in text and attribute positions alike. */
    return d.innerHTML.replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  /* ---------- toast ---------- */
  function toast(msg){var w=$('.toast-wrap')||(function(){var d=document.createElement('div');d.className='toast-wrap';d.setAttribute('aria-live','polite');document.body.appendChild(d);return d})();
    var t=document.createElement('div');t.className='toast';t.textContent=msg;w.appendChild(t);
    requestAnimationFrame(function(){t.setAttribute('data-show','true')});
    setTimeout(function(){t.removeAttribute('data-show');setTimeout(function(){t.remove()},250)},2600)}
  BLM.toast=toast;

  /* ---------- panels (drawers + modals) ----------------------------------------------
     Three things had to be true for a drawer to actually work here:

     1. It must not live inside the sticky header. `position:sticky` with a z-index creates a
        stacking context, so everything inside the header group is confined to that layer — the
        body-level scrim then paints OVER the drawer, and because the scrim closes on click, the
        first tap inside the drawer closed it. Every panel is moved to <body> on boot.
     2. A closed panel must leave the tab order. Moving it off-screen with a transform does not:
        a keyboard user walked through ~15 invisible controls on every page. `inert` (with a
        visibility fallback in CSS) takes it out of both the tab order and the a11y tree.
     3. `aria-modal="true"` is a promise that nothing outside the dialog exists. Keeping that
        promise means trapping Tab, returning focus to whatever opened it, and syncing the
        trigger's aria-expanded.
  */
  var FOCUSABLE='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function portalPanels(){
    $$('.drawer').forEach(function(el){
      if(el.parentNode!==document.body){
        /* The theme editor re-renders a section without removing the copy we moved, so drop the
           stale one first or ids collide. */
        var old=document.getElementById(el.id);
        if(old&&old!==el&&old.parentNode===document.body) old.parentNode.removeChild(old);
        document.body.appendChild(el);
      }
      if(el.getAttribute('data-open')!=='true') setInert(el,true);
    });
  }
  function setInert(el,on){
    if('inert' in HTMLElement.prototype) el.inert=on;
    if(on) el.setAttribute('aria-hidden','true'); else el.removeAttribute('aria-hidden');
  }
  function overlay(){
    var o=$('.overlay');
    if(!o){o=document.createElement('div');o.className='overlay';document.body.appendChild(o)}
    return o;
  }
  function focusables(el){
    return $$(FOCUSABLE,el).filter(function(n){ return n.offsetParent!==null||n===document.activeElement; });
  }
  function syncTriggers(el,open){
    $$('[aria-controls="'+(el.id||'').replace(/"/g,'')+'"]').forEach(function(t){
      t.setAttribute('aria-expanded',open?'true':'false');
    });
  }
  function openPanel(el){
    if(!el||el.getAttribute('data-open')==='true')return;
    el.__last=document.activeElement;
    setInert(el,false);
    el.setAttribute('data-open','true');
    syncTriggers(el,true);
    var o=overlay();
    o.setAttribute('data-open','true');
    o.onclick=function(){closePanel(el)};
    document.documentElement.style.overflow='hidden';
    var f=focusables(el); if(f.length) f[0].focus();
    el.__key=function(e){
      if(e.key==='Escape'){ closePanel(el); return; }
      if(e.key!=='Tab') return;
      var list=focusables(el); if(!list.length) return;
      var first=list[0], last=list[list.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      else if(!el.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown',el.__key);
  }
  function closePanel(el){
    if(!el)return;
    el.removeAttribute('data-open');
    syncTriggers(el,false);
    setInert(el,true);
    var o=$('.overlay'); if(o) o.removeAttribute('data-open');
    document.documentElement.style.overflow='';
    if(el.__key){document.removeEventListener('keydown',el.__key);el.__key=null}
    if(el.__last&&el.__last.focus){ try{ el.__last.focus(); }catch(e){} }
  }
  BLM.openPanel=openPanel;BLM.closePanel=closePanel;
  portalPanels();
  document.addEventListener('shopify:section:load',function(e){
    /* The theme editor swaps a section's markup in place, so anything bound at boot has to be
       re-armed against the new nodes or the section looks broken to the merchant. */
    portalPanels();
    var scope=e.target||document;
    if(BLM.initRails) BLM.initRails(scope);
    if(BLM.initTabs) BLM.initTabs(scope);
    if(BLM.initQty) BLM.initQty(scope);
    if(BLM.initAcc) BLM.initAcc(scope);
    if(BLM.initFee) BLM.initFee(scope);
    if(BLM.initCards) BLM.initCards(scope);
  });

  /* Delegated so a panel that was moved, or markup injected later, still works. */
  document.addEventListener('click',function(e){
    var open=e.target.closest&&e.target.closest('[data-open-drawer]');
    if(open){
      var d=document.getElementById(open.getAttribute('data-open-drawer'));
      if(d){ if(open.tagName==='A') e.preventDefault(); openPanel(d); }
      return;
    }
    var close=e.target.closest&&e.target.closest('[data-close-drawer]');
    /* .amodal as well as .drawer: the add-on chooser is a dialog too, and a close button that
       cannot find its own panel is a dead control. */
    if(close){ closePanel(close.closest('.drawer,.amodal')); }
  });

  /* ---------- collection sidebar (mobile off-canvas) ----------
     It is a dialog in every way that matters on a phone, so it gets the same treatment as the
     drawers: focus moves in, Tab is trapped, Escape closes, and focus returns to the button that
     opened it. Without that a keyboard user opened the filters and was left with focus parked on
     a button now behind an overlay. */
  $$('[data-col-toggle]').forEach(function(btn){
    var side=$('#'+btn.getAttribute('data-col-toggle')); if(!side) return;
    btn.setAttribute('aria-expanded','false');
    btn.setAttribute('aria-controls',side.id);
    function key(e){
      if(e.key==='Escape'){ close(); return; }
      if(e.key!=='Tab') return;
      var list=focusables(side); if(!list.length) return;
      var first=list[0], last=list[list.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      else if(!side.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
    }
    function open(){
      side.classList.add('is-open');
      btn.setAttribute('aria-expanded','true');
      var o=overlay(); o.setAttribute('data-open','true'); o.onclick=close;
      document.documentElement.style.overflow='hidden';
      document.addEventListener('keydown',key);
      var f=focusables(side); if(f.length) f[0].focus();
    }
    function close(){
      side.classList.remove('is-open');
      btn.setAttribute('aria-expanded','false');
      var o=$('.overlay'); if(o) o.removeAttribute('data-open');
      document.documentElement.style.overflow='';
      document.removeEventListener('keydown',key);
      if(btn.focus) btn.focus();
    }
    btn.addEventListener('click',open);
    var x=side.querySelector('[data-col-close]'); if(x) x.addEventListener('click',close);
  });

  /* ---------- mega menu ----------
     The panel is rendered after the nav, not inside the trigger's wrapper, so a `mouseleave` on
     the wrapper fired the moment the pointer set off toward the panel — the menu closed before it
     could be reached, and every mega item was mouse-unreachable. The close is therefore delayed
     and cancelled by entering the panel, and hovering another trigger closes whichever panel is
     actually open rather than the one belonging to the handler that happened to run. */
  (function(){
    var openPanelEl=null, openTrigger=null, timer=null;
    function shut(){
      if(openPanelEl) openPanelEl.setAttribute('data-open','false');
      if(openTrigger) openTrigger.setAttribute('aria-expanded','false');
      openPanelEl=null; openTrigger=null;
    }
    function show(trigger,panel){
      clearTimeout(timer);
      if(openPanelEl && openPanelEl!==panel) shut();
      openPanelEl=panel; openTrigger=trigger;
      panel.setAttribute('data-open','true');
      trigger.setAttribute('aria-expanded','true');
    }
    function shutSoon(){ clearTimeout(timer); timer=setTimeout(shut,220); }
    $$('[data-mega]').forEach(function(trigger){
      var panel=$('#'+trigger.getAttribute('data-mega')); if(!panel) return;
      var wrap=trigger.closest('[data-mega-wrap]')||trigger.parentNode;
      trigger.addEventListener('click',function(e){
        e.preventDefault();
        if(openPanelEl===panel) shut(); else show(trigger,panel);
      });
      wrap.addEventListener('mouseenter',function(){ show(trigger,panel); });
      wrap.addEventListener('mouseleave',shutSoon);
      panel.addEventListener('mouseenter',function(){ clearTimeout(timer); });
      panel.addEventListener('mouseleave',shutSoon);
      trigger.addEventListener('keydown',function(e){ if(e.key==='Escape'){ shut(); trigger.focus(); } });
      panel.addEventListener('keydown',function(e){ if(e.key==='Escape'){ shut(); trigger.focus(); } });
      /* Focus leaving the panel entirely closes it, so keyboard and mouse agree. */
      panel.addEventListener('focusout',function(e){
        if(!panel.contains(e.relatedTarget)&&e.relatedTarget!==trigger) shutSoon();
      });
    });
    document.addEventListener('click',function(e){
      if(!openPanelEl) return;
      if(!openPanelEl.contains(e.target)&&!(openTrigger&&openTrigger.contains(e.target))) shut();
    });
  })();

  /* ---------- sticky header: shrink on scroll (like TNE) ---------- */
  (function(){
    var header=$('.header[data-sticky]'); if(!header) return;
    /* Hysteresis: shrink once past ON, un-shrink only after coming back under OFF.
       The wide dead-zone (ON≫OFF) stops the header oscillating when you halt scrolling
       right at the boundary — shrinking the header nudges scrollY, and a single
       threshold would immediately re-cross itself and flicker. */
    var ticking=false, ON=72, OFF=16, on=false;
    function update(){
      var y=window.pageYOffset||document.documentElement.scrollTop;
      if(!on && y>ON){ on=true; header.classList.add('is-scrolled'); }
      else if(on && y<OFF){ on=false; header.classList.remove('is-scrolled'); }
      ticking=false;
    }
    /* Publish the header's real height so anchored jumps (scroll-padding) and the sticky
       collection sidebar clear it — including after it shrinks. */
    function publishHeight(){
      var g=document.querySelector('.shopify-section-group-header-group')||header;
      var h=Math.round(g.getBoundingClientRect().height);
      if(h>0) document.documentElement.style.setProperty('--header-h',h+'px');
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){update();publishHeight()}); } }, {passive:true});
    window.addEventListener('resize',publishHeight);
    header.addEventListener('transitionend',publishHeight);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(publishHeight).catch(function(){});
    update(); publishHeight();
  })();

  /* ---------- horizontal rails / carousels ----------
     One contract for every scroller in the theme (category tiles, product carousels, reels,
     testimonials, PDP add-ons):
       .rail[data-rail] > [data-rail-track] + [data-rail-prev] + [data-rail-next]
     Arrows ship `hidden` in Liquid and are only revealed when the track actually overflows, so
     a short rail (and a no-JS visit) shows no dead controls. */
  function initRails(scope){
    $$('[data-rail]',scope||document).forEach(function(rail){
      if(rail.__rail) return; rail.__rail=1;
      var track=rail.querySelector('[data-rail-track]'); if(!track) return;
      var prev=rail.querySelector('[data-rail-prev]'), next=rail.querySelector('[data-rail-next]');
      function stepPx(){
        var first=track.firstElementChild;
        var w=first?first.getBoundingClientRect().width:0;
        /* Step by whole items where we can measure one, otherwise by most of a screenful. */
        return w>40?Math.min(w*2+32,Math.max(track.clientWidth-40,w)):Math.max(track.clientWidth*0.85,220);
      }
      function update(){
        /* scrollLeft is negative under dir=rtl in current browsers, so compare on the absolute. */
        var max=track.scrollWidth - track.clientWidth - 2, x=Math.abs(track.scrollLeft), none=max<=2;
        rail.classList.toggle('is-static',none);
        if(prev) prev.hidden = none || x<=2;
        if(next) next.hidden = none || x>=max;
      }
      function go(dir){ var rtl=getComputedStyle(track).direction==='rtl'; track.scrollBy({left:(rtl?-dir:dir)*stepPx(),behavior:'smooth'}); }
      if(prev) prev.addEventListener('click',function(){ go(-1); });
      if(next) next.addEventListener('click',function(){ go(1); });
      track.addEventListener('scroll',function(){ requestAnimationFrame(update); },{passive:true});
      window.addEventListener('resize',function(){ requestAnimationFrame(update); });
      /* Images land after init and change scrollWidth — re-measure as each one arrives. */
      $$('img',track).forEach(function(im){ if(!im.complete) im.addEventListener('load',update,{once:true}); });
      if('ResizeObserver' in window){ try{ new ResizeObserver(update).observe(track); }catch(e){} }
      window.addEventListener('load',update);
      update();
    });
  }
  BLM.initRails=initRails;
  initRails();
  /* Snap is armed only after the page has settled: applying it during load fights the browser's
     own scroll restoration and can jump a rail to the wrong item. */
  window.addEventListener('load',function(){ setTimeout(function(){ document.documentElement.classList.add('snap-on'); },700); });

  /* ---------- tabs ----------
     [data-tabs-scope] wraps one tab set. The bar is [data-tabs] (role=tablist) holding
     .tabbtn[role=tab][data-tab=<panelId>]; panels are [data-panel][role=tabpanel] and inactive
     ones ship the `hidden` attribute so the no-JS page still shows the first panel only.
     A tab may carry data-cta-url / data-cta-label to drive the single [data-tab-cta] link. */
  function initTabs(scope){
    $$('[data-tabs]',scope||document).forEach(function(bar){
      if(bar.__tabs) return; bar.__tabs=1;
      var root=bar.closest('[data-tabs-scope]')||document;
      var tabs=$$('.tabbtn',bar);
      function select(tab,focus){
        tabs.forEach(function(t){
          var on=t===tab;
          t.classList.toggle('on',on);
          t.setAttribute('aria-selected',on?'true':'false');
          t.tabIndex=on?0:-1;
        });
        $$('[data-panel]',root).forEach(function(p){ p.hidden = p.id!==tab.getAttribute('data-tab'); });
        loadPanel($('#'+cssEsc(tab.getAttribute('data-tab')),root));
        var cta=$('[data-tab-cta]',root), url=tab.getAttribute('data-cta-url'), label=tab.getAttribute('data-cta-label');
        if(cta){
          if(url){ cta.href=url; cta.hidden=false; } else { cta.hidden=true; }
          if(label) cta.textContent=label;
        }
        if(tab.scrollIntoView) tab.scrollIntoView({block:'nearest',inline:'center'});
        if(focus) tab.focus();
        /* A rail that was hidden measured 0 — re-measure now that its panel is visible. */
        window.dispatchEvent(new Event('resize'));
      }
      bar.addEventListener('click',function(e){ var t=e.target.closest('.tabbtn'); if(t) select(t); });
      bar.addEventListener('keydown',function(e){
        var i=tabs.indexOf(document.activeElement); if(i<0) return;
        var rtl=getComputedStyle(bar).direction==='rtl', n=null;
        if(e.key==='ArrowRight') n=tabs[(i+(rtl?-1:1)+tabs.length)%tabs.length];
        else if(e.key==='ArrowLeft') n=tabs[(i+(rtl?1:-1)+tabs.length)%tabs.length];
        else if(e.key==='Home') n=tabs[0];
        else if(e.key==='End') n=tabs[tabs.length-1];
        if(n){ e.preventDefault(); select(n,true); }
      });
      tabs.forEach(function(t){ t.tabIndex = t.classList.contains('on')?0:-1; });
    });
  }
  BLM.initTabs=initTabs;
  initTabs();

  /* The theme editor scrolls to and highlights the block a merchant selects. A tile inside a
     closed tab panel is invisible, so selecting it looks like nothing happened — open its tab. */
  document.addEventListener('shopify:block:select',function(e){
    var panel=e.target&&e.target.closest&&e.target.closest('[data-panel]');
    if(!panel||!panel.id) return;
    var tab=document.querySelector('.tabbtn[data-tab="'+panel.id.replace(/"/g,'')+'"]');
    if(tab) tab.click();
  });

  /* ---------- scrollable tab bar with edge arrows ---------- */
  $$('[data-tabscroll]').forEach(function(wrap){
    var bar=wrap.querySelector('[data-tabs]'); if(!bar) return;
    var prev=wrap.querySelector('[data-tabscroll-prev]'), next=wrap.querySelector('[data-tabscroll-next]');
    function update(){
      var max=bar.scrollWidth - bar.clientWidth - 2, x=Math.abs(bar.scrollLeft), none=max<=2;
      if(prev) prev.hidden = none || x<=2;
      if(next) next.hidden = none || x>=max;
    }
    function go(dir){ var rtl=getComputedStyle(bar).direction==='rtl';
      bar.scrollBy({left:(rtl?-dir:dir)*Math.max(120,bar.clientWidth*0.6),behavior:'smooth'}); }
    if(prev) prev.addEventListener('click',function(){ go(-1); });
    if(next) next.addEventListener('click',function(){ go(1); });
    bar.addEventListener('scroll',function(){ requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',function(){ requestAnimationFrame(update); });
    /* Label widths change once the web font swaps in. */
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(update).catch(function(){});
    update();
  });

  /* CSS.escape isn't in every browser we support; ids here are theme-generated so a simple
     guard is enough to keep querySelector from throwing on an unexpected character. */
  function cssEsc(id){ return (window.CSS && CSS.escape) ? CSS.escape(id) : String(id||'').replace(/[^\w-]/g,''); }

  /* A tab panel whose rail carries data-lazy-src holds skeleton cards until it is first opened;
     then it fetches `{collection}?view=cards` (templates/collection.cards.liquid — markup only,
     no page chrome) and swaps the real cards in. Failing quietly leaves the skeletons, so we
     replace them with a link to the collection rather than a silent empty shelf. */
  function loadPanel(panel){
    if(!panel) return;
    var track=panel.querySelector('[data-lazy-src]'); if(!track||track.getAttribute('data-loaded')) return;
    track.setAttribute('data-loaded','1');
    fetch(track.getAttribute('data-lazy-src'),{headers:{'Accept':'text/html'}})
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        track.innerHTML=html;
        /* The shared cards view returns a fixed maximum; trim to the count this tab asked for so
           a tidy four-across rail does not become twelve the moment it is opened. */
        var want=parseInt(track.getAttribute('data-count'),10);
        if(want>0){ while(track.children.length>want) track.removeChild(track.lastElementChild); }
        initRails(panel);
        /* Without this the hearts and compare icons in the injected cards look interactive and
           silently do nothing. */
        if(BLM.initCards) BLM.initCards(panel);
        window.dispatchEvent(new Event('resize'));
      })
      .catch(function(){
        /* Leaving skeletons on screen forever reads as a broken shelf. Offer the collection. */
        track.setAttribute('data-loaded','');
        var a=document.createElement('a');
        a.className='btn btn--secondary';
        a.href=track.getAttribute('data-lazy-src').split('?')[0];
        a.textContent=(BLM.strings&&BLM.strings.browse)||'';
        track.textContent=''; track.appendChild(a);
      });
  }
  BLM.loadPanel=loadPanel;

  /* ---------- announcement bar rotation ----------
     Only runs with 2+ messages, and never when the visitor has asked for reduced motion — a bar
     that swaps itself under someone who opted out is exactly what that setting is for. */
  $$('[data-announce]').forEach(function(bar){
    var msgs=$$('[data-announce-msg]',bar); if(msgs.length<2) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i=0, every=(parseInt(bar.getAttribute('data-interval'),10)||5)*1000, timer=null;
    function show(n){ msgs.forEach(function(m,k){ m.hidden=k!==n; m.classList.toggle('is-on',k===n); }); }
    function tick(){ i=(i+1)%msgs.length; show(i); }
    function start(){ if(!timer) timer=setInterval(tick,every); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    /* Pause while the tab is in the background, and while someone is reading/hovering it. */
    document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
    bar.addEventListener('mouseenter',stop); bar.addEventListener('mouseleave',start);
    bar.addEventListener('focusin',stop); bar.addEventListener('focusout',start);
    show(0); start();
  });

  /* ---------- reels: click-to-load video facade ----------
     External players are only embedded once the visitor asks, so no third-party script or
     cookie loads on a page view. With JS off the facade is a plain link to the video. */
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('[data-reel-embed]'); if(!a) return;
    var src=a.getAttribute('data-reel-embed'); if(!src) return;
    e.preventDefault();
    var box=a.parentNode; if(!box) return;
    var f=document.createElement('iframe');
    f.className='reel__iframe'; f.src=src; f.loading='lazy';
    f.title=a.getAttribute('data-reel-title')||'';
    f.setAttribute('allow','autoplay; fullscreen; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen','');
    box.innerHTML=''; box.appendChild(f);
  });

  /* ---------- auto-submitting selects ----------
     Bound on `change`, never inline: an inline onchange fires on every arrow-key step through a
     closed <select> in Firefox and on Windows, so a keyboard user is navigated away before they
     reach the option they wanted. `change` on commit is the accessible behaviour. */
  $$('[data-auto-submit] select').forEach(function(sel){
    sel.addEventListener('change',function(){ var f=sel.form||sel.closest('form'); if(f) f.submit(); });
  });

  /* ---------- header category jump ----------
     Navigates to a category only when the search box is empty; with a query typed the customer
     clearly wants to search, so the form is submitted instead of their words being discarded. */
  $$('[data-search-cat]').forEach(function(sel){
    sel.addEventListener('change',function(){
      if(!sel.value) return;
      var form=sel.closest('form');
      var q=form&&form.querySelector('input[name="q"]');
      if(q&&q.value.trim()){ form.submit(); return; }
      window.location=sel.value;
    });
  });

  /* ---------- predictive search ----------------------------------------------------
     Results are built with createElement/textContent, never innerHTML: /search/suggest.json
     returns merchant-authored titles verbatim and does not HTML-escape them, so a product named
     with a tag would execute in every visitor's browser. Nothing user- or merchant-authored is
     ever concatenated into markup anywhere in this file. */
  $$('[data-predictive-search]').forEach(function(input){
    var panel=$('#'+input.getAttribute('data-predictive-search'));if(!panel)return;var timer,ctrl,seq=0;
    input.setAttribute('role','combobox');input.setAttribute('aria-autocomplete','list');input.setAttribute('aria-expanded','false');
    /* No aria-live here: the combobox pattern announces the active option through
       aria-activedescendant. A live region on the list re-reads every result on every keystroke. */
    function close(){panel.removeAttribute('data-open');panel.textContent='';input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant')}
    function render(items,q){
      panel.textContent='';
      if(!items.length){
        var p=document.createElement('p');p.className='hint';p.style.margin='0';
        p.textContent=input.getAttribute('data-no-results')||'';
        panel.appendChild(p);
      } else {
        items.forEach(function(it,i){
          var a=document.createElement('a');
          a.className='search-result';a.setAttribute('role','option');a.id=panel.id+'-o'+i;
          a.href=it.url;a.setAttribute('aria-selected','false');
          if(it.image){
            var img=document.createElement('img');
            img.src=it.image;img.alt='';img.width=44;img.height=44;img.loading='lazy';
            img.style.borderRadius='var(--r-xs)';img.style.objectFit='cover';
            a.appendChild(img);
          }
          var sp=document.createElement('span');sp.textContent=it.title;a.appendChild(sp);
          panel.appendChild(a);
        });
      }
      panel.setAttribute('data-open','true');input.setAttribute('aria-expanded','true');
    }
    /* routes.predictiveSearch carries the /ar prefix. Shopify currently answers HTTP 417
       "Unsupported buyer locale" for /ar/search/suggest.json on this shop — verified live — so a
       naive swap would show an empty panel on every Arabic keystroke. The first failure pins the
       request back to the default-locale endpoint for the rest of the session. Remove the
       fallback once the Markets language setting is fixed (see ADMIN-TODO). */
    var suggestBase=(window.BLM&&BLM.routes&&BLM.routes.predictiveSearch)||'/search/suggest';
    function run(q){
      if(ctrl)ctrl.abort();
      ctrl=('AbortController'in window)?new AbortController():null;
      var mine=++seq;
      var qs='?q='+encodeURIComponent(q)+'&resources[type]=product,collection,article,page&resources[limit]=6';
      fetch(suggestBase+'.json'+qs,{signal:ctrl&&ctrl.signal}).then(function(r){
        if(r.ok||suggestBase==='/search/suggest')return r.json();
        suggestBase='/search/suggest';
        return fetch(suggestBase+'.json'+qs,{signal:ctrl&&ctrl.signal}).then(function(r2){return r2.json()});
      }).then(function(d){
        /* A slower earlier request must not overwrite a newer one's results. */
        if(mine!==seq||input.value.trim()!==q)return;
        var r=(d.resources&&d.resources.results)||{};
        /* Add-ons and the hidden service/fee products cannot be bought on their own, so
           suggesting one leads to a page with no buy button. suggest.json returns `tags`, so they
           are dropped here — the results PAGE filters them in Liquid, but this dropdown is built
           from a separate endpoint the template never touches. */
        var UNBUYABLE=['add-ons','hidden'];
        var prods=(r.products||[]).filter(function(p){
          return !(p.tags||[]).some(function(t){return UNBUYABLE.indexOf(String(t).toLowerCase())>-1});
        });
        var items=[].concat(prods,r.collections||[],r.articles||[],r.pages||[]).map(function(it){
          return {title:it.title,url:it.url,image:(it.featured_image&&it.featured_image.url)||it.image||''};
        });
        render(items,q);
      }).catch(function(){});
    }
    input.addEventListener('input',function(){
      clearTimeout(timer);var q=input.value.trim();
      if(q.length<2){close();return}
      timer=setTimeout(function(){run(q)},200);
    });
    input.addEventListener('keydown',function(e){
      var opts=$$('.search-result',panel);
      var idx=opts.map(function(o){return o.getAttribute('aria-selected')==='true'}).indexOf(true);
      if(e.key==='ArrowDown'){e.preventDefault();idx=Math.min(idx+1,opts.length-1)}
      else if(e.key==='ArrowUp'){e.preventDefault();idx=Math.max(idx-1,0)}
      else if(e.key==='Enter'&&idx>-1){e.preventDefault();opts[idx].click();return}
      else if(e.key==='Escape'){close();return}
      else return;
      opts.forEach(function(o,i){
        o.setAttribute('aria-selected',i===idx?'true':'false');
        if(i===idx){
          input.setAttribute('aria-activedescendant',o.id);
          if(o.scrollIntoView) o.scrollIntoView({block:'nearest'});
        }
      });
    });
    document.addEventListener('click',function(e){if(!panel.contains(e.target)&&e.target!==input)close()});
  });

  /* ---------- delivery fee estimate ----------
     One binding for every page that shows it (product page and cart): the emirate select is a
     fee ESTIMATE, and the real fee is calculated at checkout. */
  BLM.initFee=function(scope){
    $$('[data-emirate]',scope||document).forEach(function(sel){
      if(sel.__fee) return; sel.__fee=1;
      var out=(sel.closest('.field')||document).querySelector('[data-delivery-fee]')||$('[data-delivery-fee]');
      if(!out) return;
      function paint(){
        /* One flat rate to every emirate, so the label does not vary by selection. */
        out.textContent=(window.BLM&&BLM.deliveryFee)||sel.getAttribute('data-fee-default')||'';
      }
      sel.addEventListener('change',paint); paint();
    });
  };
  BLM.initFee();

  /* ---------- quantity steppers ----------
     Shared by the product page, the cart page and the cart drawer. Clamped to the input's own
     min/max so a typed value can never post something Shopify will reject. */
  function initQty(scope){
    $$('.qty',scope||document).forEach(function(q){
      if(q.__qty) return; q.__qty=1;
      var input=$('input',q),dec=$('[data-dec]',q),inc=$('[data-inc]',q);
      if(!input) return;
      function clamp(){
        var v=parseInt(input.value,10);
        var min=parseInt(input.getAttribute('min')||'1',10);
        var max=parseInt(input.getAttribute('max')||'99',10);
        if(isNaN(v)||v<min)v=min;
        if(v>max)v=max;
        input.value=v;
      }
      if(dec)dec.addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)-1;clamp();input.dispatchEvent(new Event('change',{bubbles:true}))});
      if(inc)inc.addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)+1;clamp();input.dispatchEvent(new Event('change',{bubbles:true}))});
      input.addEventListener('change',clamp);
      input.addEventListener('blur',clamp);
    });
  }
  BLM.initQty=initQty;
  initQty();

  /* ---------- accordions ---------- */
  function initAcc(scope){
    $$('.acc__btn',scope||document).forEach(function(btn){
      if(btn.__acc) return; btn.__acc=1;
      var p=document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click',function(){
        var open=btn.getAttribute('aria-expanded')==='true';
        btn.setAttribute('aria-expanded',String(!open));
        if(p)p.hidden=open;
      });
    });
  }
  BLM.initAcc=initAcc;
  initAcc();

  /* ---------- wishlist (localStorage; stores product snapshots) ---------- */
  var WKEY='blm_wishlist';
  function wish(){try{return JSON.parse(localStorage.getItem(WKEY)||'[]')}catch(e){return[]}}
  function setWish(a){try{localStorage.setItem(WKEY,JSON.stringify(a))}catch(e){}}
  function wishHas(a,id){return a.some(function(x){return String(x.id)===String(id)})}
  BLM.getWishlist=wish;
  function bindWish(scope){
    $$('[data-wish]',scope||document).forEach(function(btn){
      if(btn.__wish) return; btn.__wish=1;
      var id=btn.getAttribute('data-wish');
      if(wishHas(wish(),id))btn.setAttribute('aria-pressed','true');
      btn.addEventListener('click',function(){var a=wish();
        if(wishHas(a,id)){a=a.filter(function(x){return String(x.id)!==String(id)});btn.setAttribute('aria-pressed','false');toast(btn.getAttribute('data-removed'))}
        else{a.push({id:id,title:btn.getAttribute('data-wish-title'),url:btn.getAttribute('data-wish-url'),image:btn.getAttribute('data-wish-image'),price:btn.getAttribute('data-wish-price')});btn.setAttribute('aria-pressed','true');toast(btn.getAttribute('data-saved'))}
        setWish(a);var c=$('[data-wish-count]');if(c)c.textContent=a.length});
    });
  }
  bindWish();
  var wc=$('[data-wish-count]');if(wc)wc.textContent=wish().length;
  /* render wishlist page if present */
  var wlBox=$('[data-wishlist-page]');
  if(wlBox){var a=wish();
    wlBox.innerHTML=a.length?('<div class="grid-products">'+a.map(function(x){return '<article class="card"><div class="card__media"><a href="'+esc(x.url)+'" tabindex="-1" aria-hidden="true">'+(x.image?'<img src="'+esc(x.image)+'" alt="'+esc(x.title)+'" width="600" height="750" loading="lazy">':'')+'</a></div><div class="card__body"><h3 class="card__title"><a href="'+esc(x.url)+'">'+esc(x.title)+'</a></h3><div class="card__price">'+esc(x.price||'')+'</div><div class="card__cta"><a class="btn btn--secondary btn--block" href="'+esc(x.url)+'">'+esc(wlBox.getAttribute('data-choose'))+'<span class="visually-hidden"> '+esc(x.title)+'</span></a></div></div></article>'}).join('')+'</div>')
      :('<div class="notice"><p style="margin:0">'+(wlBox.getAttribute('data-empty')||'No saved items yet.')+'</p><p style="margin:.5rem 0 0"><a href="'+((BLM.routes&&BLM.routes.allProducts)||'/collections/shop-all')+'">'+(BLM.strings&&BLM.strings.browse||'Browse flowers →')+'</a></p></div>');}

  /* ---------- compare (localStorage; product snapshots; max 4) ---------- */
  var CKEY='blm_compare',CMAX=4;
  function cmp(){try{return JSON.parse(localStorage.getItem(CKEY)||'[]')}catch(e){return[]}}
  function setCmp(a){try{localStorage.setItem(CKEY,JSON.stringify(a))}catch(e){}}
  function cmpHas(a,id){return a.some(function(x){return String(x.id)===String(id)})}
  function cmpCount(){var c=cmp().length;$$('[data-compare-count]').forEach(function(e){e.textContent=c})}
  BLM.getCompare=cmp;
  function bindCompare(scope){
   $$('[data-compare]',scope||document).forEach(function(btn){
    if(btn.__cmp) return; btn.__cmp=1;
    var id=btn.getAttribute('data-compare');if(cmpHas(cmp(),id))btn.setAttribute('aria-pressed','true');
    btn.addEventListener('click',function(){var a=cmp();
      if(cmpHas(a,id)){a=a.filter(function(x){return String(x.id)!==String(id)});btn.setAttribute('aria-pressed','false');toast(btn.getAttribute('data-removed')||'Removed from compare')}
      else{if(a.length>=CMAX){toast(btn.getAttribute('data-full')||('Compare holds up to '+CMAX+' items'));return}
        a.push({id:id,title:btn.getAttribute('data-compare-title'),url:btn.getAttribute('data-compare-url'),image:btn.getAttribute('data-compare-image'),price:btn.getAttribute('data-compare-price'),vendor:btn.getAttribute('data-compare-vendor'),type:btn.getAttribute('data-compare-type')});
        btn.setAttribute('aria-pressed','true');toast(btn.getAttribute('data-added')||'Added to compare')}
      setCmp(a);cmpCount();renderCompare()});
   });
  }
  bindCompare();
  cmpCount();

  /* Cards injected after load (recommendations, a lazily-loaded tab) need their wishlist and
     compare buttons bound, or they look interactive and silently do nothing. */
  BLM.initCards=function(scope){ bindWish(scope); bindCompare(scope); };
  function renderCompare(){var box=$('[data-compare-page]');if(!box)return;var a=cmp();
    if(!a.length){box.innerHTML='<div class="notice"><p style="margin:0">'+(box.getAttribute('data-empty')||'No items to compare yet.')+'</p><p style="margin:.5rem 0 0"><a href="'+esc((window.BLM&&BLM.routes&&BLM.routes.allProducts)||'/collections/shop-all')+'">'+(box.getAttribute('data-browse')||'Browse flowers →')+'</a></p></div>';return}
    var L={product:box.getAttribute('data-l-product')||'Product',price:box.getAttribute('data-l-price')||'Price',type:box.getAttribute('data-l-type')||'Type',vendor:box.getAttribute('data-l-vendor')||'Brand',remove:box.getAttribute('data-l-remove')||'Remove',view:box.getAttribute('data-choose')||'Choose options'};
    var cells=function(fn){return a.map(fn).join('')};
    box.innerHTML='<div style="margin-block-end:var(--sp-4)"><button class="btn btn--ghost" data-compare-clear>'+(box.getAttribute('data-clear')||'Clear all')+'</button></div>'+
      '<div class="compare-table-wrap"><table class="compare-table"><thead><tr><th scope="col">'+L.product+'</th>'+
        cells(function(x){return '<th scope="col" class="compare-cell-img"><a href="'+esc(x.url)+'" tabindex="-1" aria-hidden="true">'+(x.image?'<img src="'+esc(x.image)+'" alt="" width="180" height="225" loading="lazy">':'')+'</a><div style="margin-block-start:var(--sp-2)"><a href="'+esc(x.url)+'">'+esc(x.title)+'</a></div><button class="compare-remove" data-compare-remove="'+esc(x.id)+'">'+esc(L.remove)+'<span class="visually-hidden"> '+esc(x.title)+'</span></button></th>'})+'</tr></thead>'+
      '<tbody>'+
        '<tr><th scope="row">'+L.price+'</th>'+cells(function(x){return '<td>'+esc(x.price||'—')+'</td>'})+'</tr>'+
        '<tr><th scope="row">'+L.type+'</th>'+cells(function(x){return '<td>'+esc(x.type||'—')+'</td>'})+'</tr>'+
        '<tr><th scope="row">'+L.vendor+'</th>'+cells(function(x){return '<td>'+esc(x.vendor||'—')+'</td>'})+'</tr>'+
        '<tr><th scope="row"></th>'+cells(function(x){return '<td><a class="btn btn--secondary btn--block" href="'+esc(x.url)+'">'+esc(L.view)+'<span class="visually-hidden"> '+esc(x.title)+'</span></a></td>'})+'</tr>'+
      '</tbody></table></div>';
    var clr=$('[data-compare-clear]',box);if(clr)clr.addEventListener('click',function(){setCmp([]);cmpCount();renderCompare()});
    $$('[data-compare-remove]',box).forEach(function(b){b.addEventListener('click',function(){var id=b.getAttribute('data-compare-remove');setCmp(cmp().filter(function(x){return String(x.id)!==String(id)}));cmpCount();renderCompare();
      var cb=$('[data-compare="'+id+'"]');if(cb)cb.setAttribute('aria-pressed','false')})})}
  renderCompare();

  /* ---------- cart ----------------------------------------------------------------
     Shopify's AJAX cart, with the plain /cart page as the fallback whenever JS is absent or a
     request fails. Three things here are load-bearing:

     1. Add-ons and paid extras are REAL products added as their own cart lines. Shopify cannot
        put a price on a line-item property, so a tick that only wrote text would promise the
        customer something that is never billed.
     2. Those extra lines carry a hidden `_Extra` property naming what they are for. The cart
        re-reconciles them on every read, so an extra can never outlive the gift that asked for
        it, and its quantity always matches how many gifts asked.
     3. A line-item property FILE (the photo upload) only reaches Shopify from a multipart POST,
        so a form with a chosen file takes that path instead of JSON.
  */
  /* Locale-aware cart read. routes.cart carries the /ar prefix; a bare '/cart.js' from an Arabic
     page returns the default-locale payload, so the drawer rendered English product titles and
     linked to English product URLs. The WRITE endpoints (/cart/add.js, /cart/change.js,
     /cart/update.js) are deliberately left bare — they are locale-agnostic APIs and prefixing
     them buys nothing. */
  var CART_JS=((window.BLM&&BLM.routes&&BLM.routes.cart)||'/cart')+'.js';

  function cartFetch(url,opts){
    return fetch(url,Object.assign({headers:{'Content-Type':'application/json','Accept':'application/json'}},opts))
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) d.__error=true; return d; }); });
  }
  /* The badge counts PURCHASES, not cart lines. A surcharge is a line but not a thing the
     customer chose, and an add-on travels with its gift — a bouquet plus its topper is one item
     in the bag, not two. */
  function giftCount(c){
    return ((c&&c.items)||[]).filter(function(l){
      var p=l.properties||{};
      if(p['_addon_of']) return false;
      if(p['_Extra']) return false;
      return true;
    }).reduce(function(n,l){ return n+(l.quantity||0); },0);
  }
  function updateCount(c){var n=giftCount(c);$$('[data-cart-count]').forEach(function(e){e.textContent=n})}

  /* Properties beginning with an underscore are ours, not the customer's — they never show. */
  function visibleProps(props){
    var out=[];
    Object.keys(props||{}).forEach(function(k){
      var v=props[k];
      if(k.charAt(0)==='_') return;                 /* ours, not the customer's */
      if(k==='For') return;                          /* shown as a translated badge instead */
      if(v==null || String(v).trim()==='') return;
      out.push([(BLM.propNames&&BLM.propNames[k])||k,v]);
    });
    return out;
  }
  function isGift(line){ return String(((line.properties||{})['For'])||'').trim()!==''; }
  /* A managed line is a FEE the customer cannot remove on its own (the midnight surcharge, a
     paid extra). An add-on is a real product they chose, so it keeps its quantity and remove
     controls like any other line. */
  function isExtra(line){
    var k=(line.properties||{})['_Extra'];
    return !!k && k!=='_Addon';
  }

  function renderCart(c){
    var body=$('[data-cart-lines]');
    var foot=$('[data-cart-summary]');
    if(!body)return;
    if(!c.items.length){
      body.innerHTML='<div class="notice"><p style="margin:0">'+esc(BLM.strings&&BLM.strings.cartEmpty)+'</p><p style="margin:.5rem 0 0"><a href="'+esc((BLM.routes&&BLM.routes.allProducts)||'/collections/shop-all')+'">'+esc(BLM.strings&&BLM.strings.browse)+'</a></p></div>';
      if(foot) foot.hidden=true;
      return;
    }
    if(foot) foot.hidden=false;
    /* A fee is drawn under the gift that asked for it rather than as a purchase of its own. Work
       out first which fee lines that covers: one is hidden from the top level ONLY when a gift is
       about to show it, so an orphan still appears and a charge can never vanish from a cart that
       is still collecting it. A gift asks for a fee when it carries a property named after the
       fee's _Extra key — the same rule reconcileExtras bills on. */
    var nestedFee={}, feesFor={};
    c.items.forEach(function(g){
      if(isExtra(g)||((g.properties||{})['_Extra'])==='_Addon') return;
      var mine=c.items.filter(function(fx){
        if(!isExtra(fx)) return false;
        var k=(fx.properties||{})['_Extra'];
        return k&&String(((g.properties||{})[k])||'').trim()!=='';
      });
      if(mine.length){ feesFor[g.key]=mine; mine.forEach(function(fx){ nestedFee[fx.key]=true; }); }
    });
    body.innerHTML=c.items.map(function(l){
      if(nestedFee[l.key]) return '';
      var mineFees=feesFor[l.key]||[];
      /* final_price is the UNIT price: with two midnight gifts the fee line has quantity 2, and
         each gift shows one unit, so the rows still sum to the cart total. */
      var extrasTotal=mineFees.reduce(function(n,fx){ return n+fx.final_price; },0);
      var extrasRows=mineFees.length
        ? '<div class="cartline__extras"><div class="cartline__extra"><span>'+esc(l.product_title)+'</span><span>'+esc(money(l.final_line_price))+'</span></div>'+
          mineFees.map(function(fx){ return '<div class="cartline__extra"><span>+ '+esc(fx.product_title)+'</span><span>'+esc(money(fx.final_price))+'</span></div>'; }).join('')+
          '</div>'
        : '';
      var lineTotal=l.final_line_price+extrasTotal;
      /* A line can name its own picture. The acrylic topper does, because Shopify shows the
         VARIANT's image and a variant here is a material - so every gold line would be the gold
         placeholder whatever it says. Nothing else sets it, and anything that does not falls
         straight through to the line image as before. */
      var own=(l.properties||{})['_topper_img'];
      var img=own?own:(l.image?l.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2'):'');
      var props=visibleProps(l.properties).map(function(kv){
        return '<span class="cartline__prop"><b>'+esc(kv[0])+':</b> '+esc(kv[1])+'</span>';
      }).join('');
      /* A fee that is still wanted was nested under its gift and returned early above, so any
         extra reaching this point is an orphan. It keeps its controls: a charge nobody can delete
         is worse than one shown out of place. */
      var managed=false;
      var giftBadge=isGift(l)?'<span class="cartline__prop cartline__prop--gift">'+esc(BLM.strings&&BLM.strings.giftBadge)+'</span>':'';
      var qty = managed
        ? '<span class="cartline__managed">'+esc(BLM.strings&&BLM.strings.extraLine)+'</span>'
        : '<div class="qty qty--sm"><button type="button" data-cart-dec="'+esc(l.key)+'" aria-label="'+esc(BLM.strings&&BLM.strings.decrease)+'">&minus;</button>'+
          '<input type="number" min="0" inputmode="numeric" value="'+l.quantity+'" data-cart-qty="'+esc(l.key)+'" aria-label="'+esc(BLM.strings&&BLM.strings.qty)+'">'+
          '<button type="button" data-cart-inc="'+esc(l.key)+'" aria-label="'+esc(BLM.strings&&BLM.strings.increase)+'">+</button></div>'+
          '<button type="button" class="cartline__remove" data-cart-remove="'+esc(l.key)+'">'+esc(BLM.strings&&BLM.strings.remove)+'</button>';
      /* Shopify says which lines it discounted and why, but the cart never repeated it - so the
         included topper arrived as a bare 0.00, which reads as a fault rather than a gift. The
         titles come from the merchant's own discounts, and are escaped anyway. */
      /* Shopify attaches a ZERO allocation to the line that QUALIFIED for the discount as well as
         the real one to the line that received it, so the gift row read "included -AED 0.00". */
      var saving=(l.line_level_discount_allocations||[]).filter(function(a){
        return Number(a.amount)>0;
      }).map(function(a){
        var t=(a.discount_application&&a.discount_application.title)||'';
        return '<span class="cartline__saving">'+esc(t)+' \u2212'+esc(money(a.amount))+'</span>';
      }).join('');
      /* A line that costs nothing should say FREE, not 0.00 - but only when a discount actually
         zeroed it, so an ordinary percentage-off never claims to be free. */
      var priceCell=(lineTotal===0&&(l.line_level_discount_allocations||[]).length)
        ? '<b class="freetag">'+esc((BLM.strings&&BLM.strings.freeTag)||'FREE')+'</b>'
        : esc(money(lineTotal));
      return '<div class="cartline">'+
        (img?'<img src="'+esc(img)+'" alt="" width="64" height="64" loading="lazy">':'<span class="cartline__noimg" aria-hidden="true"></span>')+
        '<div class="cartline__body"><a class="cartline__title" href="'+esc(l.url)+'">'+esc(l.product_title)+'</a>'+
          (l.variant_title&&l.variant_title!=='Default Title'?'<span class="hint">'+esc(l.variant_title)+'</span>':'')+
          (giftBadge||props?'<div class="cartline__props" data-clarity-mask="true">'+giftBadge+props+'</div>':'')+
          saving+extrasRows+
        '</div>'+
        '<div class="cartline__end"><span class="cartline__price">'+priceCell+'</span>'+qty+'</div>'+
      '</div>';
    }).join('');

    var sub=$('[data-cart-subtotal]'); if(sub) sub.textContent=money(c.total_price);
    var bar=$('[data-free-bar]');
    if(bar){
      var target=(BLM.cart&&BLM.cart.freeDelivery)||0;
      if(target>0){
        bar.hidden=false;
        var left=Math.max(0,target-c.total_price);
        var pct=Math.min(100,Math.round((c.total_price/target)*100));
        var msg=left>0
          ? (BLM.strings&&BLM.strings.freeLeft||'').replace('{{ amount }}',money(left))
          : (BLM.strings&&BLM.strings.freeReached||'');
        bar.querySelector('[data-free-msg]').textContent=msg;
        bar.querySelector('[data-free-fill]').style.inlineSize=pct+'%';
        bar.querySelector('[data-free-fill]').parentNode.setAttribute('aria-valuenow',String(pct));
      } else { bar.hidden=true; }
    }
  }

  /* Extra lines follow the gifts that asked for them: quantity trued up on every read, and
     removed outright once nothing asks. Runs at most once per sync so a failed change cannot
     loop. */
  var healing=false;
  function reconcileExtras(c){
    if(healing||!c||!c.items) return Promise.resolve(false);
    var gifts=c.items.filter(function(l){ return !isExtra(l) && ((l.properties||{})['_Extra'])!=='_Addon'; });
    var extras=c.items.filter(isExtra);
    var updates={}, changed=false;

    /* ORPHANED ADD-ONS. Add-ons are the customer's own choice, so unlike fees they keep their
       quantity and remove controls and are never quantity-managed here. One thing must still
       follow the gift though: if the gift goes, they go. A topper left alone in the cart has no
       delivery date against it - its product page has no scheduler - and checkout takes it
       anyway, so the order arrives with nothing to attach it to and nowhere to send it.
       Lines added before this shipped carry no _addon_of and are deliberately left alone. */
    var liveGifts={};
    c.items.forEach(function(l){
      var t=(l.properties||{})['_gift'];
      if(t) liveGifts[t]=1;
    });
    c.items.forEach(function(l){
      if(((l.properties||{})['_Extra'])!=='_Addon') return;
      var t=(l.properties||{})['_addon_of'];
      if(t&&!liveGifts[t]){ updates[l.key]=0; changed=true; }
    });

    if(!extras.length&&!changed) return Promise.resolve(false);
    extras.forEach(function(l){
      var key=l.properties['_Extra'];
      var wanting=gifts.filter(function(g){ return String(((g.properties||{})[key])||'').trim()!==''; });
      /* Midnight is charged per GIFT PRODUCT going out at midnight, matching the other two shops:
         two gifts on the same night are two surcharges. This capped at one per order on the
         reasoning that an order has a single destination - true of the van, but the shop prices the
         service per item, not per trip. `gifts` already excludes _Addon lines, so a topper riding
         along on its gift's delivery record is never billed as a midnight of its own. Everything
         else is a thing attached to a gift, so it follows that gift's quantity. */
      var demand = key==='_Midnight'
        ? wanting.length
        : wanting.reduce(function(n,g){ return n+(g.quantity||1); },0);
      if(l.quantity!==demand){ updates[l.key]=demand; changed=true; }
    });
    if(!changed) return Promise.resolve(false);
    healing=true;
    return cartFetch('/cart/update.js',{method:'POST',body:JSON.stringify({updates:updates})})
      /* cartFetch RESOLVES on an HTTP error — it sets __error rather than rejecting — so returning
         a bare true reported a 422 as a success. refreshCart() then reloads the cart page, the
         reload re-runs this reconcile, the extras are still mismatched, it 422s again, and the
         page reloads for ever. The `healing` flag is per-page-load and cannot break that cycle.
         Treating the flag as failure means a rejected write can never trigger the reload. */
      .then(function(r){ return !(r && r.__error); })
      .catch(function(){ return false; })
      .then(function(r){ healing=false; return r; });
  }

  /* "Complete the gift" tiles are rendered with the page, before anything is known about the
     cart. This hides any whose variant is already in it — offering a teddy bear to someone who has
     just added a teddy bear reads as the shop not paying attention — and hides the whole row once
     nothing is left to offer. Runs on every cart refresh, so adding one makes it disappear. */
  function syncUpsell(cart){
    var box=$('[data-upsell]'); if(!box) return;
    var have={};
    (cart&&cart.items||[]).forEach(function(i){ have[String(i.variant_id)]=true; });
    var left=0;
    $$('[data-upsell-item]',box).forEach(function(li){
      var hide=!!have[li.getAttribute('data-variant')];
      li.hidden=hide; if(!hide) left++;
    });
    box.hidden=left===0;
  }

  BLM.refreshCart=function(open){
    return cartFetch(CART_JS).then(function(c){
      return reconcileExtras(c).then(function(did){
        /* The /cart page is server-rendered, so a reconcile there leaves stale lines on screen —
           re-render it from the server rather than showing a cart that no longer exists. */
        if(did) refreshCartPage();
        return did?cartFetch(CART_JS):c;
      });
    }).then(function(c){
      lastCart=c;
      updateCount(c);renderCart(c);syncUpsell(c);
      if(open){var d=$('#cart-drawer');if(d)openPanel(d)}
      return c;
    });
  };
  $$('[data-open-cart]').forEach(function(b){
    b.addEventListener('click',function(e){
      e.preventDefault();
      /* The icon is an <a href="/cart">; if the drawer cannot be filled, follow the link rather
         than swallowing the click and leaving the customer with no way to their cart. */
      BLM.refreshCart(true).catch(function(){ window.location=b.getAttribute('href')||'/cart'; });
    });
  });

  /* Delegated so lines re-rendered after every change keep working. */
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-cart-remove],[data-cart-inc],[data-cart-dec]');
    if(!t)return;
    e.preventDefault();
    var key=t.getAttribute('data-cart-remove')||t.getAttribute('data-cart-inc')||t.getAttribute('data-cart-dec');
    var input=$('[data-cart-qty="'+key.replace(/"/g,'\\"')+'"]');
    var q=0;
    if(t.hasAttribute('data-cart-inc')) q=(parseInt(input&&input.value,10)||0)+1;
    else if(t.hasAttribute('data-cart-dec')) q=Math.max(0,(parseInt(input&&input.value,10)||0)-1);
    changeLine(key,q);
  });
  document.addEventListener('change',function(e){
    var i=e.target.closest&&e.target.closest('[data-cart-qty]');
    if(!i)return;
    changeLine(i.getAttribute('data-cart-qty'),Math.max(0,parseInt(i.value,10)||0));
  });
  var changing=false;
  /* The cart as the last render saw it. Removing a gift needs to know which lines rode with it,
     and asking the server again for something we were just told is what made removal slow. */
  var lastCart=null;


  /* Re-read the /cart SECTION, not the whole page. window.location.reload() was correct but cost
     about 1.7s: a document load plus ~66 assets re-downloaded and every script re-executed, to
     replace markup that only needed its own innerHTML. The section render is the same server
     truth without any of that. Reload stays the fallback - slow beats wrong. */
  function refreshCartPage(){
    if(!document.body.classList.contains('template-cart')) return Promise.resolve();
    var host=document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if(!host){ window.location.reload(); return Promise.resolve(); }
    /* NO Accept: application/json. On /cart that header makes Shopify answer with the Cart
       AJAX API payload instead of the rendered section. */
    return fetch('/cart?sections=main-cart')
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(j){
        var html=j['main-cart']; if(!html) throw 0;
        var fresh=new DOMParser().parseFromString(html,'text/html')
          .querySelector('[id^="shopify-section-"]');
        if(!fresh) throw 0;
        host.innerHTML=fresh.innerHTML;
        /* initQty binds the +/- listeners straight onto the buttons, once, at boot. Swapping the
           markup hands us new buttons with nothing attached - the old full reload re-ran that
           binding for free, this does not. The theme already has one re-arm path for exactly this
           (the editor swaps sections in place too), so use it rather than invent a second. */
        host.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true,detail:{}}));
      })
      .catch(function(){ window.location.reload(); });
  }

  function changeLine(key,qty){
    /* One change at a time: the +/- buttons read the value currently painted in the drawer, so
       two rapid clicks would both start from the same stale number and one would be lost. */
    if(changing) return Promise.resolve();
    changing=true;

    /* REMOVING A GIFT TAKES ITS ADD-ONS WITH IT, IN ONE REQUEST.
       It used to take four, in order: change.js to drop the gift, cart.js to re-read, update.js
       to drop the orphans reconcileExtras had just found, cart.js again to see the result. Four
       sequential round trips is the two seconds between pressing Remove and the row going away,
       and for most of it the screen still showed a topper for a bouquet that no longer existed.
       The orphans are knowable before any of it: they are the lines whose _addon_of matches this
       line's _gift, and we already have the cart. One update.js, and its response IS the new
       cart - no re-read at all. reconcileExtras still runs on the normal refresh path and would
       still catch these; it just never gets the chance to be the slow way round. */
    if(qty===0 && lastCart && lastCart.items){
      var gone=lastCart.items.filter(function(l){ return l.key===key; })[0];
      var tok=gone&&(gone.properties||{})['_gift'];
      if(tok){
        var updates={}; updates[key]=0; var n=0;
        lastCart.items.forEach(function(l){
          if(l.key===key) return;
          if(((l.properties||{})['_addon_of'])===tok){ updates[l.key]=0; n++; }
        });
        /* THE FEE IS NOT AN ADD-ON. This path takes a gift's _addon_of siblings with it, but a
           surcharge carries no parent token — it is matched by which gift asked for it — so it
           would survive the update and sit in the cart with no gift to belong to. Work out which
           surcharges this removal orphans NOW and send them in the same request: reconciling
           afterwards cost a second POST and a third read, and left the cart page unpainted. */
        var survivors=lastCart.items.filter(function(l){ return !(l.key in updates); });
        lastCart.items.forEach(function(l){
          if(l.key in updates) return;
          var fk=(l.properties||{})['_Extra'];
          if(!fk||fk==='_Addon') return;
          var wanting=survivors.filter(function(g){
            var gp=g.properties||{};
            if(gp['_Extra']) return false;
            return String(gp[fk]||'').trim()!=='';
          });
          var demand = fk==='_Midnight'
            ? wanting.length
            : wanting.reduce(function(m,g){ return m+(g.quantity||1); },0);
          if(l.quantity!==demand){ updates[l.key]=demand; n++; }
        });
        if(n){
          return cartFetch('/cart/update.js',{method:'POST',body:JSON.stringify({updates:updates})})
            .then(function(c){
              changing=false;
              if(c&&c.items){ lastCart=c; updateCount(c); renderCart(c); syncUpsell(c); }
              refreshCartPage();
              return c;
            }).catch(function(){ changing=false; return BLM.refreshCart(false); });
        }
      }
    }

    return cartFetch('/cart/change.js',{method:'POST',body:JSON.stringify({id:key,quantity:qty})})
      .then(function(res){
        /* Shopify answers 422 when the requested quantity is not available. Re-reading the cart
           puts the real number back on screen instead of leaving the typed one there. */
        if(res&&res.__error) toast((BLM.strings&&BLM.strings.cartError)||'');
        return BLM.refreshCart(false).catch(function(){}).then(function(){
          /* The /cart page is server-rendered and renderCart() only writes into the DRAWER's
             elements, so after a change its line prices, subtotal and — critically — its
             name="updates[]" inputs still hold the old numbers. A shopper who raised a quantity in
             the drawer while standing on /cart then pressed Checkout had it silently reverted by
             those stale inputs. Re-reading from the server is the only way the two views cannot
             disagree. Same rule the reconcile path already applies a few lines above. */
          refreshCartPage();
        });
      })
      .catch(function(){ window.location=(BLM.routes&&BLM.routes.cart)||'/cart'; })
      .then(function(){ changing=false; });
  }

  /* ---------- add to cart ---------------------------------------------------------- */
  function formToItem(form){
    var fd=new FormData(form);
    var item={id:Number(fd.get('id')),quantity:Math.max(1,parseInt(fd.get('quantity')||'1',10)||1),properties:{}};
    fd.forEach(function(v,k){
      var m=k.match(/^properties\[(.+)\]$/);
      /* Empty properties are dropped so two identical items still merge into one cart line;
         File values take the multipart path instead. */
      if(m&&typeof v==='string'&&v.trim()!=='') item.properties[m[1]]=v;
    });
    var sp=fd.get('selling_plan'); if(sp) item.selling_plan=Number(sp);
    if(!Object.keys(item.properties).length) delete item.properties;
    return item;
  }
  function extrasOf(form){
    var out=[];
    /* Ticked paid extras. */
    form.querySelectorAll('input[type="checkbox"][data-fee-variant]').forEach(function(el){
      if(!el.checked) return;
      var m=(el.name||'').match(/^properties\[(.+)\]$/);
      out.push({id:Number(el.getAttribute('data-fee-variant')),quantity:1,properties:{'_Extra':m?m[1]:'_Extra'}});
    });
    /* A priced <option> (the midnight window) carries its surcharge the same way. */
    form.querySelectorAll('select').forEach(function(sel){
      var o=sel.options[sel.selectedIndex];
      var id=o&&o.getAttribute('data-fee-variant');
      if(id) out.push({id:Number(id),quantity:1,properties:{'_Extra':'_Midnight'}});
    });
    /* Selected add-on tiles. They travel with the gift, so they carry the same delivery record —
       otherwise a chocolate box arrives on the packing list with no date or window against it. */
    var d=form.querySelector('[data-sched-date]'), tsel=form.querySelector('[data-sched-time]');
    /* Not just when it arrives - when it has to be READY. A midnight slot dispatches the day
       before, and the workshop plans to that date, not the delivery date. */
    var disp=form.querySelector('[data-dispatch-date]');
    var ride={};
    if(d&&d.value) ride['Delivery date']=d.value;
    if(tsel&&tsel.value) ride['Delivery time']=tsel.value;
    if(disp&&disp.value) ride['_Dispatch date']=disp.value;
    /* Name the gift this add-on belongs to. The _gift/_addon_of token already pairs them, but
       resolving it means looking up another line - which the Shopify order page never does and
       Shopify Flow cannot do at all. A name costs one property and needs no lookup. */
    var pt=form.querySelector('[data-product-title]');
    if(pt&&pt.value) ride['_addon_for']=pt.value;
    /* Scoped to the form's OWN product, not the document. The cart-drawer upsell posts through
       this same path, and a document-wide sweep meant tapping it on a product page also added
       every add-on tile selected behind the drawer. A form outside [data-product-root] — the
       upsell, a quick-add card — correctly contributes no tiles. */
    var addonRoot = form.closest ? form.closest('[data-product-root]') : null;
    (addonRoot ? addonRoot.querySelectorAll('[data-addon][data-addon-on="true"]') : []).forEach(function(t){
      /* A typed value belongs to THIS line, not the order: the number on the foil balloon has
         nothing to do with the bouquet it travels with. */
      var props=Object.assign({'_Extra':'_Addon'},ride);
      var nlab=t.getAttribute('data-addon-note-label'), nval=t.getAttribute('data-addon-note');
      if(nlab&&nval) props[nlab]=nval;
      /* Some tiles need to record more than one value. The acrylic topper carries its Material
         plus internal _topper_* fields this way; the single note pair above cannot express that.
         Underscore-prefixed keys stay out of the customer-facing cart by the usual convention. */
      try{
        var xp=JSON.parse(t.getAttribute('data-addon-props')||'null');
        if(xp&&typeof xp==='object') Object.assign(props,xp);
      }catch(e){}

      /* ONE TILE CAN BE SEVERAL CART LINES. product.js writes the whole selection to
         data-addon-picks as {variantId: qty} and prices ALL of it into the total above Add to
         cart, but this only ever read data-addon-id — the first pick — with quantity forced to 1.
         Two red balloons and a white one were quoted for three and delivered as one. The
         collapsed id/qty pair stays as the fallback for tiles with a single variant. */
      var picks=null; try{ picks=JSON.parse(t.getAttribute('data-addon-picks')||'null'); }catch(e){}
      if(picks&&typeof picks==='object'&&Object.keys(picks).length){
        Object.keys(picks).forEach(function(vid){
          var n=Math.max(1,parseInt(picks[vid],10)||1);
          if(Number(vid)) out.push({id:Number(vid),quantity:n,properties:props});
        });
        return;
      }
      var id=Number(t.getAttribute('data-addon-id'));
      /* Its own quantity, not the gift's: an add-on is its own cart line, so ordering six
         bouquets does not order six vases. */
      var qty=Math.max(1,parseInt(t.getAttribute('data-addon-qty'),10)||1);
      if(id) out.push({id:id,quantity:qty,properties:props});
    });
    /* Two entries are the same thing only when the VARIANT and the PROPERTIES both match.
       Keying on the variant alone was right while one variant meant one tile, and became wrong the
       day the acrylic topper started emitting a row per topper: "Mariam" and "Happy Birthday" are
       the same gold variant, so the second and every one after it was silently dropped on the way
       to the cart. The shopper saw three in the card and got one.

       Genuinely identical entries MERGE rather than disappear - two rows that agree on everything
       are two of that thing, which is what Shopify would do with them server-side anyway. */
    var at={}, merged=[];
    out.forEach(function(x){
      if(!x.id) return;
      var props=x.properties||{};
      var key=x.id+'\u0000'+Object.keys(props).sort().map(function(k){
        return k+'\u0001'+String(props[k]);
      }).join('\u0002');
      if(at[key]!==undefined){ merged[at[key]].quantity+=x.quantity; return; }
      at[key]=merged.length; merged.push(x);
    });
    return merged;
  }
  function hasUpload(form){
    return Array.prototype.slice.call(form.querySelectorAll('input[type="file"]'))
      .some(function(i){ return i.name&&i.name.indexOf('properties[')===0&&i.files&&i.files.length; });
  }
  function postMultipart(form){
    var fd=new FormData(form);
    /* Same rule as formToItem: drop empty properties and empty file parts. */
    Array.prototype.slice.call(fd.entries()).forEach(function(pair){
      var k=pair[0],v=pair[1];
      if(k.indexOf('properties[')!==0) return;
      if(typeof v==='string'){ if(v.trim()==='') fd.delete(k); }
      else if(!v||!v.size) fd.delete(k);
    });
    return fetch('/cart/add',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) d.__error=true; return d; }); });
  }

  /* Remove the properties that asked for a surcharge we failed to add, so the order never
     promises a service nothing was charged for. */
  function stripExtraPromises(extras){
    var keys=extras.map(function(x){ return (x.properties||{})['_Extra']; }).filter(Boolean);
    if(!keys.length) return Promise.resolve();
    return cartFetch(CART_JS).then(function(c){
      var line=null,idx=0;
      (c.items||[]).forEach(function(li,i){
        if(isExtra(li)) return;
        var p=li.properties||{};
        if(keys.some(function(k){ return k==='_Midnight'? String(p['_Midnight']||'')!=='' : String(p[k]||'')!==''; })){ line=li; idx=i+1; }
      });
      if(!line) return null;
      var props={};
      Object.keys(line.properties||{}).forEach(function(k){
        if(k==='_Midnight'&&keys.indexOf('_Midnight')>-1) return;
        if(keys.indexOf(k)>-1) return;
        props[k]=line.properties[k];
      });
      return cartFetch('/cart/change.js',{method:'POST',body:JSON.stringify({line:idx,properties:props})});
    }).catch(function(){});
  }

  document.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('form.product-form');
    if(!form) return;
    if(form.dataset.adding==='1'){ e.preventDefault(); return; }
    /* Native validation first: the delivery date, window and gift fields are `required`, and a
       programmatic submit would otherwise skip them. */
    if(typeof form.checkValidity==='function'&&!form.checkValidity()){
      e.preventDefault(); form.reportValidity(); return;
    }
    e.preventDefault();
    var buyNow=!!(e.submitter&&e.submitter.hasAttribute('data-buy-now'));
    form.dataset.adding='1';

    /* The sticky bar's button lives OUTSIDE the form (wired with form=), so a form-scoped
       lookup would miss the one the customer most likely pressed. */
    var btns=Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'))
      .concat(Array.prototype.slice.call(document.querySelectorAll('[data-sticky-bar] [type="submit"]')));
    btns.forEach(function(b){
      b.dataset.wasDisabled=b.disabled?'1':'';
      b.disabled=true;b.setAttribute('aria-busy','true');b.classList.add('is-loading');
    });

    var committed=false;
    var extras=extrasOf(form);
    var upload=hasUpload(form);

    /* PARENT LINK. Add-ons are separate cart lines with no inherent relationship to the gift they
       were chosen for, so removing the gift left them stranded - and a stranded add-on carries no
       delivery date of its own (its product page has no scheduler) yet checkout accepts it. An
       order then arrives for a topper with nowhere to send it.
       Both sides get a shared token: the gift is stamped _gift and each add-on _addon_of.
       reconcileExtras() then takes them with it when the gift goes.
       Only minted when add-ons are actually selected - a unique property on EVERY add would stop
       Shopify merging repeat adds of the same product into one line. */
    var addonLines=extras.filter(function(x){ return ((x.properties||{})['_Extra'])==='_Addon'; });
    var giftToken='';
    if(addonLines.length){
      giftToken='g'+Date.now().toString(36)+Math.random().toString(36).slice(2,7);
      addonLines.forEach(function(x){
        x.properties=Object.assign({},x.properties,{'_addon_of':giftToken});
      });
    }
    /* The upload path posts the FORM, so the token has to ride in as a real field there. */
    var tokenField=null;
    if(giftToken&&upload){
      tokenField=document.createElement('input');
      tokenField.type='hidden'; tokenField.name='properties[_gift]'; tokenField.value=giftToken;
      form.appendChild(tokenField);
    }
    /* Everything in ONE request wherever possible. Adding the gift and then its surcharges
       separately meant a failure between the two left the gift carrying a midnight window, or a
       ticked extra, with nothing charged for it. A photo upload has to go on its own because a
       line-item property FILE only survives a multipart POST — that path repairs itself below. */
    var baseItem=null;
    if(!upload){
      baseItem=formToItem(form);
      if(giftToken) baseItem.properties=Object.assign({},baseItem.properties,{'_gift':giftToken});
    }
    var first = upload
      ? postMultipart(form)
      : cartFetch('/cart/add.js',{method:'POST',body:JSON.stringify({items:[baseItem].concat(extras)})});
    if(tokenField) tokenField.remove();

    first.then(function(res){
      if(res&&res.__error) throw res;
      committed=true;
      if(!extras.length||!upload) return null;
      return cartFetch('/cart/add.js',{method:'POST',body:JSON.stringify({items:extras})}).then(function(r2){
        if(r2&&r2.__error){
          /* The upload landed but its surcharges did not. Strip the promises off that line rather
             than leaving an order that asks for midnight delivery and pays for nothing. */
          return stripExtraPromises(extras).then(function(){ throw r2; });
        }
        return r2;
      });
    }).then(function(res2){
      if(res2&&res2.__error) throw res2;
      /* The emirate lives on the cart page only — the product page does not ask for it, since
         the destination is confirmed once for the whole order and priced at checkout. The cart's
         select writes its attribute when the cart form is submitted, so if an add happens while
         that select is on screen, carry the current choice through rather than let it drift. */
      var em=document.querySelector('[data-emirate]');
      if(em&&em.value) return cartFetch('/cart/update.js',{method:'POST',body:JSON.stringify({attributes:{'Delivery-Emirate':em.value}})});
      return null;
    }).then(function(){
      document.querySelectorAll('[data-addon][data-addon-on="true"]').forEach(function(t){
        t.setAttribute('data-addon-on','false'); t.classList.remove('is-added');
        var b=t.querySelector('[data-addon-toggle]'); if(b) b.setAttribute('aria-pressed','false');
        var q=t.querySelector('[data-addon-qtybox]'); if(q) q.hidden=true;
        t.setAttribute('data-addon-qty','1');
      });
      if(window.BLM&&BLM.paintTotal) BLM.paintTotal();
      return BLM.refreshCart(!buyNow).catch(function(){});
    }).then(function(){
      if(buyNow){ window.location.href=(window.BLM&&BLM.routes&&BLM.routes.checkout)||'/checkout'; return; }
      toast(BLM.strings&&BLM.strings.added);
    }).catch(function(err){
      /* Shopify's own message is untranslated English, so it is not shown to the customer; the
         cart is re-read instead so they see exactly what did and did not go in. */
      if(window.console&&err) console.error('[cart] add failed:',err);
      if(!committed&&!upload&&!extras.length){
        /* Only safe when nothing extra was selected: the native post adds one item, so falling
           back with extras ticked would record a promise the store never charges for. */
        form.dataset.adding=''; form.submit(); return;
      }
      toast(BLM.strings&&BLM.strings.cartError);
      BLM.refreshCart(true).catch(function(){});
    }).then(function(){
      delete form.dataset.adding;
      btns.forEach(function(b){
        b.disabled=b.dataset.wasDisabled==='1';
        delete b.dataset.wasDisabled;
        b.removeAttribute('aria-busy');b.classList.remove('is-loading');
      });
    });
  });

  /* ---------- form validation + double-submit guard (non-cart forms) ---------- */
  document.addEventListener('submit',function(e){var form=e.target;if(!form.matches('[data-validate]')||form.matches('.product-form'))return;var ok=true;
    $$('[required]',form).forEach(function(f){var wrap=f.closest('.field');var val=(f.value||'').trim();
      var bad=!val||(f.type==='email'&&!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val))||(f.getAttribute('data-phone')!=null&&!/^(\+?971|0)?[0-9]{9}$/.test(val.replace(/\s/g,'')));
      if(wrap){wrap.classList.toggle('field--error',bad);var er=$('.field__error',wrap);if(er)er.hidden=!bad;f.setAttribute('aria-invalid',bad?'true':'false')}if(bad)ok=false});
    var hp=$('.honeypot input',form);if(hp&&hp.value){e.preventDefault();return}
    if(!ok){e.preventDefault();var firstBad=$('.field--error [required]',form);if(firstBad)firstBad.focus();return}
    var btn=$('[type="submit"]',form);if(btn){btn.classList.add('is-loading');btn.setAttribute('aria-busy','true')}});
  window.addEventListener('pageshow',function(){$$('.btn.is-loading').forEach(function(b){b.classList.remove('is-loading');b.removeAttribute('aria-busy')})});

  /* The boot read is best-effort: a failure here must not stop the rest of the page, but callers
     that offer a fallback (the cart icon) need the rejection, so it is not swallowed inside
     refreshCart itself. */
  if($('[data-cart-count]'))BLM.refreshCart(false).catch(function(){});

  /* ---------- product recommendations ----------
     Deferred until the customer is near them, then the wishlist/compare buttons inside the
     injected markup are bound — without this they look interactive and do nothing. */
  var rec=$('[data-product-recommendations]');
  if(rec && rec.dataset.url && !rec.querySelector('.grid-products')){
    var load=function(){
      fetch(rec.dataset.url).then(function(r){return r.text()}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var inner=doc.querySelector('[data-product-recommendations]');
        if(inner&&inner.innerHTML.trim()){
          rec.innerHTML=inner.innerHTML;
          /* The section ships `hidden` so it never paints an empty band before the fetch lands;
             clearing it here is what actually makes recommendations visible. */
          rec.hidden=false;
          BLM.initCards(rec);
        } else { rec.hidden=true; }
      }).catch(function(){ rec.hidden=true; });
    };
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){ if(en[0].isIntersecting){ io.disconnect(); load(); } },{rootMargin:'400px'});
      io.observe(rec);
    } else { load(); }
  }

  /* SELF-HEAL ON LOAD. The remove control on the cart page is a plain link, so removing a gift is
     a full navigation: Shopify drops the line, the page reloads, and nothing JavaScript does ever
     runs over the result — leaving the orphaned surcharge on screen and still charged. The sweep
     below is the same reconcile the JS paths use, and refreshCart() already repaints the cart page
     when it changes something. One small /cart.js read per page load. */
  function sweepOnLoad(){
    try { if (BLM && typeof BLM.refreshCart === 'function') BLM.refreshCart(false).catch(function(){}); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweepOnLoad);
  else sweepOnLoad();
})();
